/* @jsx h */
import { defineComponent, h, ref, onMounted } from "vue";
import type { UpdateAction } from "@app/utils/clientBusiness";
import { useToast } from "./Toast";
import { LemmonModal } from "@lemmonhq/uikit";
import { api } from "@app/data/api";

export const UpdatesProvider = defineComponent({
  name: "UpdatesProvider",
  setup(_, { slots }) {
    const toast = useToast();

    const action = ref<UpdateAction | null>(null);

    const fetchUpdateStatus = async () => {
      // 🔧 Replace with actual API call
      const params = {};
      const call = await api.fetchAppUpdates(params);
      let resp = { type: "none" } as UpdateAction;
      if (resp.type === "toast") {
        toast.showToast(resp.message, {
          type: "info",
        });
      }
      action.value = resp;
    };

    onMounted(() => {
      fetchUpdateStatus();
      setInterval(fetchUpdateStatus, 1000 * 60 * 15);
    });

    return () => (
      <>
        {slots.default?.()}
        {(() => {
          const update = action.value;
          if (!update || update.type === "toast" || update.type === "none") return null;

          const sharedModalBody = (icon: string, title: string, message: string) => (
            <div class="flex flex-col gap-4 p-4">
              <div class="flex items-center gap-2 text-xl font-semibold text-accent">
                <span>{title}</span>
              </div>
              <div class="flex flex-col gap-4 justify-center items-center">
                <span style="font-size: 190px;" class="material-symbols-outlined text-6xl text-primary">
                  {icon}
                </span>
                <p class="text-base text-accent">{message}</p>
              </div>
            </div>
          );

          if (update.type === "reload") {
            return (
              <LemmonModal onClose={() => null}>
                {sharedModalBody("refresh", update.title, update.message)}
                <div class="p-4 pt-0">
                  <button
                    class="btn btn-outline w-full flex items-center gap-2"
                    onClick={() => window.location.reload()}
                  >
                    <span class="material-symbols-outlined text-2xl">refresh</span>
                    {update.actionLabel}
                  </button>
                </div>
              </LemmonModal>
            );
          }

          if (update.type === "restart") {
            return (
              <LemmonModal onClose={() => null}>
                {sharedModalBody("restart_alt", update.title, update.message)}
                <div class="p-4 pt-0"></div>
              </LemmonModal>
            );
          }

          if (update.type === "update") {
            return (
              <LemmonModal onClose={() => null}>
                {sharedModalBody("ios", update.title, update.message)}
                <div class="p-4 pt-0 flex gap-2">
                  <a href={update.url} target="_blank" class="btn btn-outline w-full flex items-center gap-2">
                    <span class="material-symbols-outlined text-2xl">android</span>
                    Play Store
                  </a>
                </div>
              </LemmonModal>
            );
          }

          return null;
        })()}
      </>
    );
  },
});
